export const SET_STATIC_DEFAULT_CONTENT = 'SET_STATIC_DEFAULT_CONTENT';

export function setStaticDefaultContentAction(value, additionalValue) {
  return {
    type: SET_STATIC_DEFAULT_CONTENT,
    value,
    additionalValue,
  }
}